import * as React from 'react';
import { useState, useEffect, useCallback }  from 'react';
import { app } from '../config/app.js';
import Grid from '@mui/material/Grid';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Alert from '@mui/material/Alert';
import {  getPermission } from '../controller/user.js';
import {  getDataByKey } from '../controller/firestore.js';
import { updateDocToDb } from '../controller/firestore.js';
import Button from '@mui/material/Button';
import dayjs from 'dayjs';
import { DateTimeField } from '@mui/x-date-pickers/DateTimeField';

import { DateField } from '@mui/x-date-pickers';
import {  Navigate , Link } from 'react-router-dom';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';

import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import { useLocation } from 'react-router-dom';
import { Dialog, DialogActions, DialogContent, DialogTitle, ListItemButton, ListItemText, Radio, RadioGroup } from '@mui/material';
import TuneTwoToneIcon from '@mui/icons-material/TuneTwoTone';

export const FilterRecord = (props)  => {
    const collectionName=props.collectionName;
    const onFormSubmitParentEvent=props.onFilterChange;
    let filters=props.filters;
    if (!filters) filters={};
    const viewName=props.viewName;
    
    
    const viewConfig=app.collections_config[collectionName].views[viewName];
    let filterList=[];
    let currentFilters={};
    viewConfig.fieldList.forEach(element => {
      if (element.filter!=null)  {
        filterList.push(element);
        if (filters[element.field]!=null)
          currentFilters[element.field]=filters[element.field];
        else {
          let renderType=element.filter.type;
          if (renderType==null) {
            renderType="text";
          }
          if (!element.filter.match) element.filter.match=app.filterByType[renderType];
          currentFilters[element.field]={"value":"","type":element.filter.match[0]};
        }
      }
    });
    const [formData,setFormData]=useState(currentFilters);
    const title="";
    const actionText="Cerca";

    if (viewConfig==null) return '';
    if (viewConfig.filter!==true) return '';
    async function  handleSubmitForm(event) {  
      event.preventDefault();
      onFormSubmitParentEvent(formData);
    }
    const handleChangeData= (item,value) => {
      let curForm=formData;
      curForm[item.field].value=value;
      setFormData(curForm);
    
    };
    const handleChangeType= (item,value) => {
   //   console.log("Handled change type",item,value);
      let curForm={...formData};
     // curForm[item.field]={...formData[item.field]};
      curForm[item.field].type=value;
    //  console.log("curForm === formData:", curForm === formData);
     // console.log("curFormField === formData:", curForm[item.field] === formData[item.field]);
   //   console.log(curForm);
      setFormData(curForm);
    
    };
    return (
      <React.Fragment>
        {formData && 
        <form onSubmit={handleSubmitForm}>
        <Typography sx={{pb:2}} variant="h6" gutterBottom>
          {title}
        </Typography>
        <Grid container spacing={2} >
        { filterList && filterList.map( gridElement => (
         
          <Grid item key={gridElement.field} {...gridElement.filter.gridProp}>
              <Grid container spacing={1}>
                <Grid item md={11} xs={10}><RenderItemFilter name={gridElement.field} item={gridElement} value={formData[gridElement.field] ? formData[gridElement.field].value : ''} handleChangeData={handleChangeData} /></Grid>
                <Grid item md={1} xs={1}><RenderFilterTypes2 name={gridElement.field}  item={gridElement}  types={gridElement.filter.match} value={formData[gridElement.field] ? formData[gridElement.field].type : ''} handleChange={handleChangeType} /></Grid>
              </Grid>
          </Grid>
  
        ))}
        
        </Grid>
        <Stack sx={{mt:2}} align="right" direction="row" spacing={2}>
          <Button  type="submit" color="success" variant="contained">{actionText}</Button>
        </Stack>
        </form>
        }
      </React.Fragment> );
  }

function RenderFilterTypes(props) {

  const item=props.item;
  const key=props.name;
  const types=props.types;
  const handleChangeParent=props.handleChange;
  let value=props.value;
  const name=key+"-type";
  const label="Tipo";
  const labelId=key+"-type-label";
  useEffect(() => {
    if (value!=null)
      setValueInput(value);
  }, [value]); 
  function changedValue(e) {
    let curValue=null;
    if (e==null) {
      setValueInput(curValue);
      handleChangeParent(item,curValue);
      return;
    }
    if (e.$isDayjsObject) 
      curValue=e.$d;
    else 
      curValue=e.target.value;
    
    setValueInput(curValue);
    handleChangeParent(item,curValue);
      
  };
    
  const [valueInput, setValueInput] = useState(value);
  if (!value) value=types[0];
  return (
    <FormControl  fullWidth>
    <InputLabel   id={labelId}>{label}</InputLabel>
    
  <Select fullWidth onChange={changedValue} labelId={labelId} variant="outlined"  id={name} name={name} label={label} value={valueInput}>

  {
    types.map(option => (
        <MenuItem key={option} value={option} selected={option === value}>{app.codeToLabel[option]}</MenuItem>  )
    )
  }
  </Select>
  </FormControl>
  );
}

function RenderFilterTypes2(props) {

  const item=props.item;
  const key=props.name;
  const types=props.types;
  const handleChangeParent=props.handleChange;
  let value=props.value;
  const name=key+"-type";
  const label="Tipo";
  const labelId=key+"-type-label";
  const [open, setOpen] = React.useState(false);
  const handleClose = (newValue) => {
    setOpen(false);

   
  };
  const handleClickListItem = () => {
    setOpen(true);
  };
  /*useEffect(() => {
    if (value!=null)
      setValueInput(value);
  }, [value]); 
  function changedValue(e) {
    let curValue=null;
    if (e==null) {
      setValueInput(curValue);
      handleChangeParent(item,curValue);
      return;
    }
    if (e.$isDayjsObject) 
      curValue=e.$d;
    else 
      curValue=e.target.value;
    
    setValueInput(curValue);
    handleChangeParent(item,curValue);
      
  };
    
  const [valueInput, setValueInput] = useState(value);*/
  if (!value) value=types[0];
  return (
    <FormControl fullWidth sx={{ mt: 0.9 }}>
      <ListItemButton onClick={handleClickListItem}>
        <TuneTwoToneIcon />
      </ListItemButton>
      <ConfirmationDialogRaw
        id={name}
        keepMounted
        open={open}
        onClose={handleClose}
        value={value}
        types={types}
        title={label}
        handleChange={handleChangeParent}
        item={item}
      />
    </FormControl>
  );
}
function RenderItemFilter({item,value,handleChangeData}) {
  const [asyncOptionData, setAsyncOptionData] = useState(null);
  
  let asyncRequired=false;
  
  function changedValue(e) {
    let curValue=null;
    if (e==null) {
      setValueInput(curValue);
      handleChangeData(item,curValue);
      return;
    }
    if (e.$isDayjsObject) 
      curValue=e.$d;
    else 
      curValue=e.target.value;
      setValueInput(curValue);
      handleChangeData(item,curValue);
    
  };
  const labelId=item.field+"-label";
  useEffect(() => {
    async function fetchData() {
      try {
        const obtainedData=await app.services[item.option_service]["func"](item,value);
        setAsyncOptionData(obtainedData);
        
      } catch (error) {
        console.error('Errore nella chiamata asincrona', error);
        
      }
    }
    if (asyncRequired && asyncOptionData===null)
      fetchData(); // Esegui la chiamata asincrona solo una volta all'avvio del componente
  }, []); 

  useEffect(() => {
    if (value!==null || value !==undefined)
    setValueInput(value);
  }, [value]); 

    
  const [valueInput, setValueInput] = useState(value);
  
  if (item.debug) console.log("Value input "+item.field,valueInput);

  let renderType=item.filter.type;
  if (renderType==null) {
    renderType="text";
  }
  
    switch (renderType) {
      case 'select':
        let options=item.filter.options;
        
        if (item.filter.option_service) { 
          const service=item.filter.option_service;
          asyncRequired=app.services[service].async;
          if (!asyncRequired) options=app.services[service].func(item,value);
        }
        
        return ( 
        <FormControl fullWidth>
        <InputLabel id={labelId}>{item.headerName}{item.required ? '*':''}</InputLabel>
        <Select fullWidth {...item.textProp} onChange={changedValue} variant="outlined"  labelId={labelId} id={item.field} name={item.field} label={item.headerName} value={valueInput}>
        <MenuItem key={""} value={""} selected={"" === value}>-</MenuItem> {
            asyncRequired ? 
              (
                (
                  asyncOptionData ===null ? 
                  (
                    <div>Loading</div>
                  )  :
                  (
                
                    asyncOptionData.map(option => (
                      <MenuItem key={option.value} value={option.value} selected={option.value === valueInput}>{option.label}</MenuItem>               
                    ))

                  )
                )
              ) : (
                (
                  options ===null ? 
                  (
                    
                    <div>Loading synced</div>
                  ):
                  (
                    options.map(option => (
                      <MenuItem key={option.value} value={option.value} selected={option.value === valueInput}>{option.label}</MenuItem>               
                    ))
                  )
                )
              )
          }
          </Select></FormControl>);
      case 'boolean':
        return <FormControl fullWidth><TextField  fullWidth {...item.textProp} onChange={changedValue} variant="standard"  id={item.field} name={item.field} label={item.headerName}/></FormControl>;
      case 'date':
        return  <FormControl fullWidth><DateField  onChange={changedValue} variant="outlined" label={item.headerName} {...item.textProp}  id={item.field} name={item.field} value={(valueInput!=""?dayjs(valueInput):null)}  /></FormControl>;
      case 'datetime':
        return  <FormControl fullWidth><DateTimeField  onChange={changedValue} variant="outlined" label={item.headerName} {...item.textProp}  id={item.field} name={item.field} value={(valueInput!=""?dayjs(valueInput):null)}  /></FormControl>;
      
      default:
        return <TextField fullWidth {...item.textProp} onChange={changedValue} variant="outlined" value={valueInput} id={item.field} name={item.field} label={item.headerName}  />;
    }
  
}

function ConfirmationDialogRaw(props) {
  
  const open=props.open;
  const valueProp=props.value;
  const onClose=props.onClose;
  const types=props.types;
  const handleChangeParent=props.handleChange;
  const item=props.item;
  const title=props.title;
  const [value, setValue] = React.useState(valueProp);
  const radioGroupRef = React.useRef(null);
  
  React.useEffect(() => {
    if (!open) {
      setValue(valueProp);
    }
  }, [valueProp, open]);

  const handleEntering = () => {
    if (radioGroupRef.current != null) {
      radioGroupRef.current.focus();
    }
  };

  const handleCancel = () => {
    onClose();
  };

  const handleOk = () => {
    onClose(value);
  };

  const handleChange = (event) => {
 //   console.log("Changed value RADIO",event.target.value);
    
    handleChangeParent(item,event.target.value);
  };

  return (
    <Dialog
      sx={{ '& .MuiDialog-paper': { width: '80%', maxHeight: 435 } }}
      maxWidth="xs"
      TransitionProps={{ onEntering: handleEntering }}
      open={open}
    >
      <DialogTitle>{title}</DialogTitle>
      <DialogContent dividers>
        <RadioGroup
          ref={radioGroupRef}
          aria-label={title}
          name={title}
          value={valueProp}
          onChange={handleChange}
        >
    
          {types && types.map((option) => (
            <FormControlLabel
              value={option}
              key={option}
              control={<Radio />}
              label={app.codeToLabel[option]}
            />
          ))}
        </RadioGroup>
      </DialogContent>
      <DialogActions>
        
        <Button onClick={handleOk}>Ok</Button>
      </DialogActions>
    </Dialog>
  );
}